import $ from 'jquery';
import _ from 'lodash';
import toastr from 'toastr';

let focused = false,
    threshold = 30000;

export default {
    init() {
        setInterval(this.getNotifications, threshold);

        $(document).bind('visibilitychange', () => focused = !document.hidden);

        // For IE
        $(window).blur(() => focused = false);
        $(window).focus(() => focused = true);

        focused = !document.hidden;

        toastr.options.timeOut = 10000;

        this.getNotifications();
    },

    getNotifications() {
        if (!focused) return;

        $.ajax({
            url: '/track/notifications/rest/growl',
            contentType: 'application/json; charset: utf-8',
            data: {
                ignore_session: 1
            },
            type: 'GET',
            success(data) {
                let growls = data.notifications;

                _.each(growls, (growl) => {
                    let severity = growl.metadata.severity;

                    if (growl.metadata.onclick) {
                        toastr.options.onclick = new Function(growl.metadata.onclick);
                    }
                    if (growl.metadata.link) {
                        toastr.options.onclick = function() {
                            window.location = growl.metadata.link;
                        };
                    }
                    toastr[severity](growl.message, growl.title);
                });
            }
        });
    }
};



/** WEBPACK FOOTER **
 ** ./js/app/common/notifications.js
 **/